"use client";

import { LoaderCircle } from "lucide-react";
import { useGetCaptions } from "../../../../hooks/useGetCaptions";
import EditCaptions from "./editCaptions";
import VideoWorkflowStep from "../videoWorkflow/videoWorkflowStep";
import { Label } from "@/components/ui/label";
import { GetVideoResponseType } from "@/features/storage/sheets/hooks/useGetVideo";
import { useState } from "react";
import { TabValue } from "../../main";
import { t } from "@/lib/localization";

export default function CaptionsTab({
    captions,
    setReloadVideoKey,
    changeTab,
}: {
    captions: GetVideoResponseType["data"]["captions"];
    setReloadVideoKey: (key: number) => void;
    changeTab: (value: TabValue) => void;
}) {
    const [currentCaptionsId, setCurrentCaptionsId] = useState<
        string | undefined
    >(captions.find((c) => c.isSpokenLanguage)?.id);

    const { isPending, data } = useGetCaptions(currentCaptionsId);

    console.log({ currentCaptionsId, data });

    if (currentCaptionsId && isPending) {
        return (
            <div className="flex w-full py-24 justify-center items-center">
                <LoaderCircle className="size-5 animate-spin" />
            </div>
        );
    }

    if (data?.data?.srt) {
        return (
            <EditCaptions
                captionsId={data.data.id}
                srt={data.data.srt}
                srclang={data.data.srclang}
                published={data.data.published || false}
                transcription={data.data.extendedTranscription ?? null}
                setReloadVideoKey={setReloadVideoKey}
                captions={captions}
                setCurrentCaptionsId={setCurrentCaptionsId}
                changeTab={changeTab}
            />
        );
    }

    return (
        <div className="mt-4">
            <div className="mb-6">
                <Label className="">
                    {t("video-sheet.captions-tab.title", undefined, undefined)}
                </Label>
                <p className="text-sm text-muted-foreground">
                    {t(
                        "video-sheet.captions-tab.description",
                        undefined,
                        undefined
                    )}
                </p>
            </div>
            <VideoWorkflowStep
                stepName="captions"
                texts={{
                    title: {
                        keyName: "video-sheet.create-captions-with-ai.title",
                        defaultValue: "יצירת כתוביות עם AI",
                    },
                    description: {
                        keyName:
                            "video-sheet.create-captions-with-ai.description",
                        defaultValue:
                            "צרו כתוביות מדוייקות ברמה הגבוהה ביותר לסרטון שלכם",
                    },
                    generateBtn: {
                        keyName: "video-sheet.generate-captions-with-ai-btn",
                        defaultValue: "יצירה",
                    },
                }}
            />
        </div>
    );
}
